import React, { useEffect, useState } from 'react';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

// Shared UI Library Components
import { SpinElement } from '@ppmcore/seven-ppm-core-shared-components-react';

// Styles
import './counsellor-layout.scss';

// Components
import { AsideMenu } from './components/aside-menu/aside-menu';
import { CounsellorHeader } from './components/counsellor-header/counsellor-header';

// Store Entities
import { getCounsellorProfile } from '../../store/current-counsellor/current-counsellor.thunks';
import { getCoreState } from '../../store/core/core.selectors';
import { getCurrentCounsellorState } from '../../store/current-counsellor/current-counsellor.selectors';

type TMainLayoutProps = {};

export const CounsellorLayout = ({}: TMainLayoutProps) => {
  const params = useParams<{ id: string }>();

  const [loadingProfile, setLoadingProfile] = useState<boolean>(true);

  const { path } = useSelector(getCoreState);
  const { counsellor, loading } = useSelector(getCurrentCounsellorState);

  const navigate = useNavigate();
  const dispatch = useDispatch<any>();

  const loadCounsellor = async (): Promise<void> => {
    if (!params.id) {
      navigate('/counsellors');
      return;
    }
    setLoadingProfile(true);
    const { payload } = await dispatch(getCounsellorProfile(params.id));
    if (payload) {
      setLoadingProfile(false);
      return;
    }
    navigate('/404');
  }

  useEffect(() => {
    loadCounsellor();
  }, []);

  return (
    <div className="counsellor-layout">
      <div className="counsellor-layout--header">
        { counsellor && <CounsellorHeader counsellor={ counsellor }/> }
      </div>

      {
        loading &&
        <div className={ `counsellor-layout--loader counsellor-layout--loader-${ loading ? 'show' : 'hide' }` }>
          <SpinElement fullHeight={ true }/>
        </div>
      }

      <div className="counsellor-layout--content">
        <div className="content-aside">
          { counsellor && <AsideMenu pathState={ path } counsellorId={ counsellor?.id }/> }
        </div>
        { !loadingProfile && <div className="content-body">
          <Outlet/>
        </div> }
      </div>
    </div>
  );
}
